import axios from '@/utils/request';

const deviceApi = {
  getSubSystemList(params) {
    return axios({
      url: '/api/v1/subsystem/list',
      method: 'get',
      params,
    });
  },
  getDeviceTypeList(params) {
    return axios({
      url: '/api/v1/deviceType/list',
      method: 'get',
      params,
    });
  },
  async findSameDeviceType(data) {
    return axios({
      url: '/api/v1/device/findSameDeviceType',
      method: 'post',
      data,
    });
  },
  // 判断设备是否存在接口
  checkDeviceExist(params) {
    return axios({
      url: '/api/v1/device/isExist',
      method: 'get',
      params,
    });
  },
  // 根据设备编码模糊匹配接口
  async getDeviceListByNameOrCode(params) {
    return axios({
      url: '/api/v1/device/listByNameOrCode',
      method: 'get',
      params,
    });
  },
  async getDeviceListByIdOrCode(params) {
    return axios({
      url: '/api/v1/device/get',
      method: 'GET',
      params,
    });
  },
  // 点位值设定接口 (全面接入云端控制指令中心)
  async setPointValue(pointCode, value, stationId) {
    return await this.sendCloudCommand(pointCode, value, stationId);
  },
  async sendCloudCommand(pointCode, value, stationId) {
    const userProfileStr = localStorage.getItem('userProfile');
    let username = '';
    try {
      if (userProfileStr) {
        const u = JSON.parse(userProfileStr);
        username = u.account || u.name || '';
      }
    } catch (e) {}

    const token = localStorage.getItem('userToken') || localStorage.getItem('user-token') || '';
    const headers = {
      'X-Operator': encodeURIComponent(username),
    };
    if (token) {
      headers['Authorization'] = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
    }

    const response = await axios({
      url: '/api/v1/commands/send',
      method: 'post',
      headers,
      data: {
        station_id: stationId || '',
        command_type: 'SINGLE_POINT_WRITE',
        parameters: {
          point_code: pointCode,
          value: value,
          operator: username,
        },
      },
    });

    if (response && response.ok) {
      return {
        code: 200,
        msg: '控制指令已成功送达云端控制队列！',
        command_id: response.command_id,
        isCloudQueue: true,
        data: response,
      };
    }
    return {
      code: 500,
      msg: (response && response.error && response.error.message) || (response && response.message) || '云端指令下发异常',
    };
  },
  getCommandStatus(commandId) {
    return axios({
      url: `/api/v1/commands/${commandId}/status`,
      method: 'get',
    });
  },
  // 列表查询设备
  listDevice(params) {
    return axios({
      url: '/api/v1/device/list',
      method: 'get',
      params,
    });
  },
  // 根据设备编码获取设备，精确匹配
  getDeviceByCode(deviceCode) {
    return axios({
      url: '/api/v1/device/list',
      method: 'GET',
      params: {
        deviceCode,
        rowLimit: -1,
      },
    }).then((res) => {
      let iotDevice = null;
      if (res.code == 200) {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].deviceCode == deviceCode) {
            iotDevice = res.data[i];
            break;
          }
        }
      }
      return iotDevice;
    });
  },
};

export default deviceApi;
